import { PlacementRuleType } from '../../../api/generated';
import type { EditorNode } from './types';

export interface NodeProps {
  wi: EditorNode;
  strokeColor: string;
  fillColor: string;
  isOverlay?: boolean;
  allWeekInterventions: EditorNode[];
  getWiName: (wiId: string) => string;
  getWiLabel: (wiId: string) => string;
  onRemove: () => void;
  onRemoveDep: (depId: string) => void;
  onAddDep: (type: PlacementRuleType, targetId?: string) => void;
  onEditAllowedDays: (rect: DOMRect) => void;
}

/** Append "33" (20% alpha) to a 6-char hex so it can be used as a card fill. */
export const fillFromColor = (color: string) => (color.length === 7 ? `${color}33` : color);
